import React, { useState } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Alert,
  Spinner,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import { useEditMode } from "../Context/EditModeContext";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function Login() {
  const navigate = useNavigate();
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const [email, setEmail] = useState("");
  const { setAuth } = useAuth();
  const { setIsEditMode } = useEditMode();
  const [password, setPassword] = useState("");
  const [errorMessages, setErrorMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessages([]);

    const lowerCaseEmail = email.toLowerCase();

    console.log("Attempted login...");

    try {
      console.log("calling request for login");
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "auth/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ email: lowerCaseEmail, password }),
        }
      );

      const data = await response.json();
      console.log(data);

      if (!response.ok) {
        if (Array.isArray(data.message)) {
          setErrorMessages(data.message);
        } else {
          setErrorMessages([data.message || t("login_error")]);
        }
        return;
      }

      if (data.twoFactorRequired) {
        // Rediriger vers la page 2FA si la 2FA est requise
        navigate("/2fa", { state: { email } });
        return;
      }

      if (!data.user) {
        setErrorMessages([t("login_error")]);
        return;
      }

      // Désactiver le mode édition après connexion
      setIsEditMode(false);

      // Mettre à jour AuthContext
      setAuth(data.user._id, data.user.role, true);

      // Redirection après connexion réussie
      navigate("/programs");
      setIsLoading(false);
    } catch (err) {
      setErrorMessages([t("unexpected_error")]);
      console.log("login err", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center h-100">
      <Container>
        <Row className="justify-content-center">
          <Col md={4} className="shadow m-4 p-4">
            <h2 className="text-center mb-4">{t("login_title")}</h2>

            <Form onSubmit={handleLogin}>
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>{t("email_label")}</Form.Label>
                <Form.Control
                  type="email"
                  placeholder={t("email_placeholder")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="password">
                <Form.Label>{t("password_label")}</Form.Label>
                <Form.Control
                  type="password"
                  placeholder={t("password_placeholder")}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>
              <Button type="submit" variant="primary" className="w-100">
                {isLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  t("login_button")
                )}
              </Button>
              {errorMessages && (
                <div className="text-danger mt-2">{errorMessages[0]}</div>
              )}
            </Form>
            <div className="text-center mt-3">
              {t("no_account")}{" "}
              <Link onClick={() => navigate("/signup")}>
                {t("signup_link")}
              </Link>
            </div>
            {/* Lien Forgot Password */}
            <div className="text-center mt-2">
              <Link to="/forgot-password">{t("forgot_password_link")}</Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Login;
